var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-switch mr-50",class:[_vm.toggle ? 'active' : ''],on:{"click":_vm.clickToggle}},[_c('div',{staticClass:"barra",class:[_vm.toggle ? 'active' : '']})])}
var staticRenderFns = []

export { render, staticRenderFns }